export default {"src":"/_next/static/media/check.9cb101ba.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};